import React, { useEffect } from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import SummaryCard from "../../components/Cards/SummaryCard";
import DonutChart from "../../components/Charts/DonutChart";
import useCustomerDashboard from "../../hooks/dashboard/useCustomerDashboard";

const ClientsDashboard: React.FC = () => {
  const { stats, fetchStats } = useCustomerDashboard();

  useEffect(() => {
    fetchStats();
  }, []);

  // ✅ Construimos dinámicamente los labels y series
  const taxpayerLabels = Object.keys(stats.customersByTaxpayerCategory || {});
  const taxpayerSeries = Object.values(stats.customersByTaxpayerCategory || {});

  const entityLabels = Object.keys(stats.customersByEntityType || {});
  const entitySeries = Object.values(stats.customersByEntityType || {});

  // ✅ Paletas de colores seguras
  const taxpayerColors = ["#3C50E0", "#16A34A", "#F59E0B", "#F97316", "#10B981"];
  const entityColors = ["#8FD0EF", "#0FADCF", "#6366F1", "#FBBF24"];

  return (
    <DefaultLayout>
      {/* ✅ Tarjetas resumen siempre visibles */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-4 2xl:gap-7.5">
        <SummaryCard
          title="Total de Clientes"
          value={stats.totalCustomers.toString()}
          rate=""
          iconName="user-management"
        />
        <SummaryCard
          title="Clientes Activos"
          value={stats.activeCustomers.toString()}
          rate=""
          iconName="user-management"
        />
        <SummaryCard
          title="Clientes Inactivos"
          value={stats.inactiveCustomers.toString()}
          rate=""
          iconName="user-management"
        />
      </div>

      {/* ✅ DonutCharts siempre visibles */}
      <div className="mt-6 flex flex-col gap-4 md:flex-row md:gap-6">
        <div className="w-full md:w-1/2">
          <DonutChart
            title="Clientes por categoría tributaria"
            labels={taxpayerLabels}
            series={taxpayerSeries}
            colors={taxpayerColors.slice(0, taxpayerLabels.length)}
          />
        </div>

        <div className="w-full md:w-1/2">
          <DonutChart
            title="Clientes por tipo de entidad"
            labels={entityLabels}
            series={entitySeries}
            colors={entityColors.slice(0, entityLabels.length)}
          />
        </div>
      </div>
    </DefaultLayout>
  );
};

export default ClientsDashboard;
